module.exports = __webpack_public_path__ + "static/ms777-05171d502664aa46a728a558a992ada2.jpg";